/* חיבור ל-Supabase. הכתובת והמפתח מגיעים מ-.env (VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY),
   ואם חסרים, מהמסך "חיבור ל-Supabase" שנשמר בדפדפן. */
import { createClient } from '@supabase/supabase-js';

const ENV_URL = import.meta.env.VITE_SUPABASE_URL || '';
const ENV_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

let client = null;

export function getConfig() {
  if (ENV_URL && ENV_KEY) return { url: ENV_URL, key: ENV_KEY, fromEnv: true };
  const url = localStorage.getItem('sb_url'), key = localStorage.getItem('sb_key');
  return url && key ? { url, key, fromEnv: false } : null;
}

export function saveConfig(url, key) {
  localStorage.setItem('sb_url', url);
  localStorage.setItem('sb_key', key);
  client = null;
}
export function clearConfig() {
  localStorage.removeItem('sb_url');
  localStorage.removeItem('sb_key');
  client = null;
}

/** מצב הדגמה: לקוח מדומה במקום Supabase */
export function setClient(c) {
  client = c;
}

export function sb() {
  if (client) return client;
  const c = getConfig();
  if (!c) throw new Error('Supabase לא מוגדר');
  client = createClient(c.url, c.key, { auth: { persistSession: true, autoRefreshToken: true } });
  return client;
}

/** תוצאת שאילתה, או שגיאה בעברית */
export async function q(promise) {
  const { data, error } = await promise;
  if (error) throw new Error(error.message || error.hint || 'שגיאה בשמירה');
  return data;
}

export async function accessToken() {
  const { data } = await sb().auth.getSession();
  return data.session ? data.session.access_token : '';
}
